import { FC, useEffect } from 'react';
import classNames from 'classnames';
import { motion, useAnimationControls } from 'framer-motion';
import { useCallbackRef } from '@restart/hooks';
import AdvertListFilterControlsCss from '#srcCssModules/advert/list-filter/advert-list-filter-controls.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';
import { useWidth } from '#advertList/components/filter/hooks/use-width';
import { Toggle } from '#advertList/components/filter/controls/Toggle';
import { usePositionUpdater } from '#advertList/components/filter/hooks/use-position-updater';
import { FilterItemList } from '#advertList/components/filter/controls/FilterItemList';

const Controls: FC = () => {
  const {
    isVisible,
    onChangeSubject,
  } = useFilterContext();
  const [actions, attachRefActions] = useCallbackRef<HTMLDivElement>();
  const [actionsInner, attachRefActionsInner] = useCallbackRef<HTMLDivElement>();
  const { actionsWidth, actionsInnerWidth } = useWidth(actions, actionsInner);
  const animationControls = useAnimationControls();
  const { update } = usePositionUpdater(actions, actionsWidth, actionsInnerWidth, animationControls);

  useEffect(() => {
    if (!actionsInnerWidth) {
      return;
    }

    update();
  }, [actionsInnerWidth, update]);

  useEffect(() => {
    const subscription = onChangeSubject.subscribe((url) => {
      update(url);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [actionsInnerWidth, onChangeSubject, update]);

  return (
    <div
      className={classNames(
        AdvertListFilterControlsCss.advertListFilterControls,
        { [AdvertListFilterControlsCss.advertListFilterControls_active]: isVisible },
      )}
    >
      <Toggle />
      <div ref={attachRefActions} className={AdvertListFilterControlsCss.advertListFilterControls__actions}>
        <motion.div
          ref={attachRefActionsInner}
          className={classNames(AdvertListFilterControlsCss.advertListFilterControls__actionsInner)}
          drag="x"
          dragTransition={{
            min: -actionsInnerWidth + actionsWidth,
            max: 0,
          }}
          dragConstraints={{
            right: 0,
            left: -actionsInnerWidth + actionsWidth,
          }}
          animate={animationControls}
        >
          <FilterItemList />
        </motion.div>
      </div>
    </div>
  );
};

export { Controls };
